import * as React from 'react';
import TextField from '@mui/material/TextField';

const CoreTextArea = ({ ...props }) => {
    return (

        <TextField
            multiline
            {...props}

        />
    )
}

export default CoreTextArea
